__turbopack_context__.v({
  "card": "topAuction-module-scss-module__4EHksW__card",
  "card__content": "topAuction-module-scss-module__4EHksW__card__content",
  "card__content__description": "topAuction-module-scss-module__4EHksW__card__content__description",
  "card__content__imageContainer": "topAuction-module-scss-module__4EHksW__card__content__imageContainer",
  "card__content__manufacturer": "topAuction-module-scss-module__4EHksW__card__content__manufacturer",
  "card__price": "topAuction-module-scss-module__4EHksW__card__price",
  "imageWrapper": "topAuction-module-scss-module__4EHksW__imageWrapper",
});
